module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('form', {
    staticClass: "form-horizontal well"
  }, [_c('fieldset', [(!this.$route.params.id) ? _c('legend', [_vm._v("New Transmitter")]) : _vm._e(), _vm._v(" "), (this.$route.params.id) ? _c('legend', [_vm._v("Edit Transmitter")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Callsign")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Enter a valid amateur radio callsign of this transmitter. It will be also used for the 10 minute interval transmitter identification message to fulfill the law (at least the German law).")]), _vm._v(" "), (_vm.editing) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Changing this name will create a duplication and "), _c('i', [_vm._v("not")]), _vm._v(" change the element's name.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.hamnetDb.all,
      "multiple": false,
      "close-on-select": true,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.formData.hamnetDb.selected),
      callback: function($$v) {
        _vm.formData.hamnetDb.selected = $$v
      },
      expression: "formData.hamnetDb.selected"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Easy import of stations from hamnetdb.net. Location data of the selected transmitter site will be copied into the form.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Node")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.nodes,
      "close-on-select": true,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.node),
      callback: function($$v) {
        _vm.form.node = $$v
      },
      expression: "form.node"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Select the DAPNET-Node which shall receive the transmitter TCP connection. Just this DAPNET-Node will accept a connection from this specific transmitter.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Enter a authentication password for this transmitter. In the UniPager webinterface it’s called Auth Key.")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Latitude / Longitude")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.latitude.value),
      expression: "form.latitude.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "90",
      "placeholder": "0 - 90"
    },
    domProps: {
      "value": (_vm.form.latitude.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.latitude.value = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.latitude.orientation),
      expression: "form.latitude.orientation",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.form.latitude.orientation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("North")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("South")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.longitude.value),
      expression: "form.longitude.value",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "180",
      "placeholder": "0 - 180"
    },
    domProps: {
      "value": (_vm.form.longitude.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.longitude.value = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.longitude.orientation),
      expression: "form.longitude.orientation",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val)
        });
        _vm.form.longitude.orientation = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("East")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "-1"
    }
  }, [_vm._v("West")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Usage")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.usage),
      expression: "form.usage"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.usage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PERSONAL"
    }
  }, [_vm._v("Personal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WIDERANGE"
    }
  }, [_vm._v("Widerange")])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("For classification of the transmitters, there are two categories: Personal (Transmitters with low output power like RasPager) and Wide Range (Higher output power and elevated location site).")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Antenna Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.antennatype),
      expression: "form.antennatype"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.antennatype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "OMNI"
    }
  }, [_vm._v("Omni")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DIRECTIONAL"
    }
  }, [_vm._v("Directional")])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Please select if you have a omnidirectional antenna (e.g. X-50) or a directional antenna (e.g. Yagi).")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.antennadirection),
      expression: "form.antennadirection",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "disabled": _vm.form.antennatype === 'OMNI',
      "min": "0",
      "max": "359",
      "placeholder": "0 - 359"
    },
    domProps: {
      "value": (_vm.form.antennadirection)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.antennadirection = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Other")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.power),
      expression: "form.power",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "200",
      "placeholder": "0 - 200"
    },
    domProps: {
      "value": (_vm.form.power)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.power = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.antennalevel),
      expression: "form.antennalevel",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "1000",
      "placeholder": "0 - 1000"
    },
    domProps: {
      "value": (_vm.form.antennalevel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.antennalevel = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-5 col-lg-offset-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.antennagain),
      expression: "form.antennagain",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "-50",
      "max": "80",
      "placeholder": "-50 - 80"
    },
    domProps: {
      "value": (_vm.form.antennagain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.antennagain = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.form.identificationAddress),
      expression: "form.identificationAddress",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "2097151",
      "placeholder": "0 - 2097151"
    },
    domProps: {
      "value": (_vm.form.identificationAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.identificationAddress = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Timeslots")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tr', [_c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "0") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "0",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "1") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "2") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "3") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "4") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "5") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "6") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "7"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "7") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "7",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "8"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "8") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "8",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "9"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "9") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "9",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "A"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "A") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "A",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "B"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "B") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "B",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "C"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "C") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "C",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "D"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "D") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "D",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "E"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "E") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "E",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.timeslot),
      expression: "form.timeslot"
    }],
    staticClass: "timeslotCheckBox",
    attrs: {
      "type": "checkbox",
      "value": "F"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.timeslot) ? _vm._i(_vm.form.timeslot, "F") > -1 : (_vm.form.timeslot)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.form.timeslot,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "F",
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.form.timeslot = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.form.timeslot = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.form.timeslot = $$c
        }
      }
    }
  })])])])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAs all transmitters use the same frequency a time division multiplex access scheme is used.\n\t\t\t\t\t\t\t\tThere are 16 timeslots available.\n\t\t\t\t\t\t\t\tAssign the slots of this transmitter according to you surrounding transmitters in your neighborhood without overlapping timeslots that are assigned to more than one transmitter.\n\t\t\t\t\t\t\t\tYou can use the transmitter map to check already assigned timeslots of adjacent transmitters.\n\t\t\t\t\t\t\t\tIn case that you cannot fulfill your requirements, contact the adjacent transmitter owners and try to get an agreement.\n\t\t\t\t\t\t\t\tNormally four 4 or less timeslots per transmitter are more than enough.\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-lg-2 control-label"
  }, [_vm._v("Owner")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.formData.users,
      "multiple": true,
      "close-on-select": false,
      "hide-selected": true,
      "clear-on-select": true,
      "placeholder": "Type to search",
      "label": "name",
      "track-by": "name"
    },
    model: {
      value: (_vm.form.owners),
      callback: function($$v) {
        _vm.form.owners = $$v
      },
      expression: "form.owners"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("If you are an owner, you can change the parameters for this transmitter.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-lg-10 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/transmitters"
    }
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Abort")])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('h2', [_vm._v("Information")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [(_vm.form.device.type) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Device")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.form.device.type))])]) : _vm._e(), _vm._v(" "), (_vm.form.device.version) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Version")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.form.device.version))])]) : _vm._e(), _vm._v(" "), (_vm.form.address.ip_addr) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("IP-Address")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.form.address.ip_addr))])]) : _vm._e(), _vm._v(" "), (_vm.form.address.port) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Port")]), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.form.address.port))])]) : _vm._e(), _vm._v(" "), (_vm.form.connection.last || _vm.form.connection.since) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Connection")]), _vm._v(" "), _c('ul', [(_vm.form.connection.last) ? _c('li', [_vm._v("Last: "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.form.connection.last))])]) : _vm._e(), _vm._v(" "), (_vm.form.connection.since) ? _c('li', [_vm._v("Since: "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.form.connection.since))])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("This table shows the registered paging transmitters, their online status and additional information. Personal transmitters have low output power and a very small coverage. Wide range transmitters are usually installed at elevated locations leading to a wide coverage area.")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Transmitters")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v("Antenna main beam direction")]), _vm._v(": Enter the antenna main beam direction in degrees according to \"True North\" (in German \"rechtweisend Nord\").")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v("Transmitter Power")]), _vm._v(": Enter the transmitter output power including your cable losses.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v("Antenna elevation over ground")]), _vm._v(": Enter the antenna elevation over ground; NOT over NN (!) in meters.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v("Antenna gain")]), _vm._v(": Enter the antenna gain in the main lobe direction for directional antennas and the average gain for omnidirectional antennas in dBi (dBi: Gain over isotropic radiator).")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-block"
  }, [_c('b', [_vm._v("Transmitter identification RIC")]), _vm._v(": Enter a RIC (default value is 1) which will be used to generate an artificial paging message containing the amateur radio callsign as given in this form.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v("1")]), _vm._v(" "), _c('td', [_vm._v("2")]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_vm._v("4")]), _vm._v(" "), _c('td', [_vm._v("5")]), _vm._v(" "), _c('td', [_vm._v("6")]), _vm._v(" "), _c('td', [_vm._v("7")]), _vm._v(" "), _c('td', [_vm._v("8")]), _vm._v(" "), _c('td', [_vm._v("9")]), _vm._v(" "), _c('td', [_vm._v("A")]), _vm._v(" "), _c('td', [_vm._v("B")]), _vm._v(" "), _c('td', [_vm._v("C")]), _vm._v(" "), _c('td', [_vm._v("D")]), _vm._v(" "), _c('td', [_vm._v("E")]), _vm._v(" "), _c('td', [_vm._v("F")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b2928bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/transmitter/New.vue
// module id = 620
// module chunks = 1